import * as React from "react";
import { createLink, LinkComponent } from "@tanstack/react-router";
import {
  Anchor,
  type AnchorProps,
  NavLink,
  ActionIcon,
  type NavLinkProps,
  type ActionIconProps,
} from "@mantine/core";

//
// Anchor component
//

interface MantineAnchorProps extends Omit<AnchorProps, "href"> {}

const MantineLinkComponent = React.forwardRef<
  HTMLAnchorElement,
  MantineAnchorProps
>((props, ref) => {
  return <Anchor ref={ref} {...props} />;
});

MantineLinkComponent.displayName = "MantineLinkComponent";

const CreatedLinkComponent = createLink(MantineLinkComponent);

export const TanstackMantineLink: LinkComponent<typeof MantineLinkComponent> = (
  props,
) => {
  return <CreatedLinkComponent preload="intent" {...props} />;
};

//
// NavLink component
//
interface MantineNavLinkProps extends Omit<NavLinkProps, "href"> {}

const MantineNavLinkComponent = React.forwardRef<
  HTMLAnchorElement,
  MantineNavLinkProps
>((props, ref) => {
  return <NavLink ref={ref} {...props} />;
});

MantineNavLinkComponent.displayName = "MantineNavLinkComponent";

const CreatedNavLinkComponent = createLink(MantineNavLinkComponent);

export const TanstackMantineNavLink: LinkComponent<
  typeof MantineNavLinkComponent
> = (props) => {
  return <CreatedNavLinkComponent preload="intent" {...props} />;
};

//
// ActionIcon
//
interface MantineActionIconProps extends Omit<ActionIconProps, "onClick"> {}

const MantineActionIcon = React.forwardRef<
  HTMLAnchorElement,
  MantineActionIconProps
>((props, ref) => {
  return <ActionIcon component="a" ref={ref} {...props} />;
});

MantineActionIcon.displayName = "MantineActionIcon";

const CreatedActionIcon = createLink(MantineActionIcon);

export const TanstackActionIcon: LinkComponent<typeof MantineActionIcon> = (
  props,
) => {
  return <CreatedActionIcon preload="intent" {...props} />;
};
